import { Alert, Button, Grid, ImageList, ImageListItem } from '@mui/material';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { gridSizeMdLg12 } from '@/shared';
import { useEffect, useState } from 'react';
import { useCreatePhoto } from '../actions/noc-module.actions';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { SaveFormData } from '@/shared/actions/erp';

export type AddPhotosModalProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    idActivitiesOrder: any;
    refetch: () => void;
    onSave: (valor: number) => void;
};

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const AddPhotosModal: React.FC<AddPhotosModalProps> = ({
    open,
    setOpen,
    idActivitiesOrder,
    refetch,
    onSave
}) => {

    const [images, setImages] = useState<
        { file: File; preview: string }[]
    >([]);

    const useCreatePhotoMutation = useCreatePhoto();

    const handleClose = () => {
        setOpen(false);
    };

    const [isLoading, setIsLoading] = useState(false);

    const addPhotos = async () => {
        if (images.length === 0) {
            toast.error("Debe seleccionar al menos una imagen");
            return;
        }

        const formData = new FormData();

        images.forEach((file) => {
            formData.append("filePhotoReport", file.file);
        });

        formData.append("idActivitiesOrder", idActivitiesOrder);

        setIsLoading(true);
        useCreatePhotoMutation.mutate(formData, {
            onSuccess: async () => {
                toast.success("Fotos agregadas correctamente");
                setImages([]);
                setOpen(false);
                refetch();
                setIsLoading(false);
            },
            onError: (error) => {
                toast.error("Error al agregar las fotos");
                console.error(error);
                setIsLoading(false);
            }
        });

        onSave(0)

    };

    useEffect(() => {
        return () => {
            images.forEach(img => URL.revokeObjectURL(img.preview));
        };
    }, [images]);

    return (
        <>
            <ScrollableDialogProps
                open={open}
                title={"Agregar Fotos"}
                width="100%"
                contentNode={
                    <>
                        {isLoading && (
                            <Grid item {...gridSizeMdLg12}>
                                <Alert severity="info">
                                    Subiendo fotografías, por favor espere...
                                </Alert>
                            </Grid>
                        )}
                        <Grid container spacing={3}>
                            <Grid item {...gridSizeMdLg12}>
                                <Button
                                    component="label"
                                    role={undefined}
                                    variant="contained"
                                    tabIndex={-1}
                                    startIcon={<CloudUploadIcon />}
                                >
                                    Cargar Archivos
                                    <VisuallyHiddenInput
                                        type="file"
                                        onChange={(event) => {
                                            if (!event.target.files) return;

                                            const selected = Array.from(event.target.files).map(file => ({
                                                file,
                                                preview: URL.createObjectURL(file),
                                            }));

                                            setImages(selected);
                                        }}
                                        multiple
                                    />
                                </Button>
                            </Grid>

                            <Grid item {...gridSizeMdLg12}>
                                <ImageList cols={4} gap={4}>
                                    {images.map((img, index) => (
                                        <ImageListItem key={index}>
                                            <img
                                                src={img.preview}
                                                alt={img.file.name}
                                                loading="lazy"
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Grid>
                            {isLoading && (
                                <Grid item {...gridSizeMdLg12}>
                                    <Alert severity="info">
                                        Subiendo fotografías, por favor espere...
                                    </Alert>
                                </Grid>
                            )}
                        </Grid>
                    </>
                }
                onClose={handleClose}
                confirmDisabled={isLoading}
                onConfirm={addPhotos}
            />
        </>
    );
}

export default AddPhotosModal;